import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { NEVER, Observable, catchError, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '@ff/loader';
import { loaderHide } from '../shared/shared.module';
import { TokenService } from '../_services/token.service';
import { isNil } from 'lodash';

@Injectable()
export class TokenExpireInterceptor implements HttpInterceptor {
  constructor(
    private router: Router, 
    private _tokenService: TokenService,
    private loader: LoaderService
    ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (!!err.status && err.status === 401 && this.router.url !== '/auth/login' && this.router.url !== '/') {
            if (!isNil(localStorage.getItem('_token'))) {
              // TOKEN HAS EXPIRED
              return this._tokenService.refreshToken().pipe(
                switchMap((res: any) => {
                  if (!isNil(res) && !isNil(res.code) && res.code == 200 && !isNil(res?.data?.token)){
                    localStorage.setItem('_token', res?.data?.token);
                    const token = localStorage.getItem('_token');
                    let headers = new HttpHeaders();
                    if (req.headers) {
                        headers = req.headers;
                    }
                    if (token) {
                        headers = headers
                            .set('Accept', `application/json`)
                            .set('Authorization', `Bearer ${token}`);
                    }
                    const duplicate = req.clone({ headers: headers });
                    return next.handle(duplicate);
                  }
                }),
                catchError(err => {
                  return throwError(() => err);
                })
              );

            }
            loaderHide(this.loader);
          }
          return throwError(() => {
            if (err instanceof HttpErrorResponse) {
              if (!!err.status && (err.status === 401 || err.status === 403) && this.router.url !== '/auth/login' && this.router.url !== '/') {
                localStorage.clear();
                this.router.navigate(['/']).then(() => window.location.reload());
                return NEVER;
              }
            }
            return err;
          });
        }
      })
    );
  }
}
